import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import DeleteModal from '@Shared.Angular/flowingly.components/DeleteModal/DeleteModal';

const DeleteModalBridge = react2angular(DeleteModal, [
  'id',
  'title',
  'subject',
  'closeModal',
  'deleteAction',
  'confirmationWord'
]);

export default DeleteModalBridge;
